import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { debitCardReceiptPdfStyle as style } from "components/WaysToPay/DebitCardSuccessPage/debitCardReceiptPdfStyle";
import { format } from "date-fns";
import { formatAmount } from "library/moneyUtils";
import { FC } from "react";
import creditCard from "../../../images/credit-card.png";
import headerImage from "../../../images/thumbnail_lsc-menu@2x.png";

interface DebitCardReceiptPdfProps {
  product: {
    cardName: string;
    cardEndsWith: string;
  };
  amount: number;
  receiptNumber: string;
  paymentDate: Date;
  debitCardEndsWith: string;
}

export const DebitCardReceiptPdf: FC<DebitCardReceiptPdfProps> = ({
  product,
  amount,
  paymentDate,
  debitCardEndsWith,
  receiptNumber,
}) => (
  <Document>
    <Page style={style.page}>
      <View style={style.header}>
        <Image style={style.headerImage} src={headerImage} />
      </View>
      <View style={style.main}>
        <Text style={style.title}>Debit card payment receipt</Text>
        <View style={style.card}>
          <Image style={style.cardImage} src={creditCard} />
          <View>
            <Text>{product.cardName}</Text>
            <Text style={style.cardEnding}>
              Card ending {product.cardEndsWith}
            </Text>
          </View>
        </View>
        <View style={style.table}>
          <View style={{ ...style.row, ...style.firstRow }}>
            <Text style={style.label}>Amount</Text>
            <Text style={style.value}>
              {formatAmount(amount, { withCents: true })}
            </Text>
          </View>
          <View style={style.row}>
            <Text style={style.label}>Card Ending</Text>
            <Text style={style.value}>{`•••• ${debitCardEndsWith}`}</Text>
          </View>
          <View style={style.row}>
            <Text style={style.label}>Payment date</Text>
            <Text style={style.value}>
              {format(paymentDate, "dd MMMM yyyy")}
            </Text>
          </View>
          <View style={style.row}>
            <Text style={style.label}>Receipt number</Text>
            <Text style={style.value}>{receiptNumber}</Text>
          </View>
        </View>
      </View>
    </Page>
  </Document>
);
